export default function isChrome(): boolean {
  // @ts-ignore
  return typeof window !== 'undefined' && !!window?.chrome;
}
